import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Organizations cannot be renamed from the website or command line interface.`}</p>
    <p>{`To rename an organization, as an organization owner, you must manually migrate your existing organization members, teams, and packages to a new organization, then `}<a parentName="p" {...{
        "href": "https://www.npmjs.com/support"
      }}>{`contact npm Support`}</a>{` to have the outdated packages unpublished and the previous organization deleted.`}</p>
    <ol>
      <li parentName="ol"><a parentName="li" {...{
          "href": "creating-an-organization"
        }}>{`Create a new organization`}</a>{` with the name you want. If your old organization is on a paid plan, you must choose a paid plan for the new organization.`}</li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "adding-members-to-your-organization"
        }}>{`Add the members`}</a>{` of your old organization to your new organization.`}</li>
      <li parentName="ol">{`In your new organization, `}<a parentName="li" {...{
          "href": "creating-teams"
        }}>{`create teams`}</a>{` to match teams in your old organization.`}</li>
      <li parentName="ol">{`Republish packages to the new organization by updating the package scope in its `}<inlineCode parentName="li">{`package.json`}</inlineCode>{` file to match the new organizationanization name and running `}<inlineCode parentName="li">{`npm publish`}</inlineCode>{`.`}</li>
      <li parentName="ol">{`In the new organization teams, `}<a parentName="li" {...{
          "href": "managing-team-access-to-packages"
        }}>{`configure package access`}</a>{` to match team package access in your old organization.`}</li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "https://www.npmjs.com/support"
        }}>{`Contact npm Support`}</a>{` to have the outdated packages unpublished and the previous organization deleted.`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      